import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {},
	buttonCard: {
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: theme.spacing(1.5),
	},
	nfcCardHeader: {
		margin: theme.spacing(3, 0, 2, 0),
	},
	nfcCard: {
		display: 'flex',
		flexDirection: 'column',
		padding: theme.spacing(2, 2),
	},
	userCard: {
		display: 'flex',
	},
	userCardHeader: {
		margin: theme.spacing(2, 0),
	},
	avatar: {
		margin: theme.spacing(2, 1, 2, 2),
	},
	labelCard: {
		margin: theme.spacing(2, 0),
	},

	emailLabel: {
		...theme.typography.body3,
	},
	closeButton: {
		marginTop: theme.spacing(1),
		marginRight: theme.spacing(1),
		marginLeft: 'auto',
		alignSelf: 'flex-start',
	},
}));
